/**
 * @generated SignedSource<<f15234cea50fcc2324aa47745a3ab796>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CurriculumDashboardBlockCardViewQuery$variables = {
  first?: number | null;
  id: string;
};
export type CurriculumDashboardBlockCardViewQuery$data = {
  readonly product: {
    readonly curriculum?: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"CurriculumDashboardBlockCardViewPaginationFragment">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"usePermissionsFragment">;
  } | null;
};
export type CurriculumDashboardBlockCardViewQuery = {
  response: CurriculumDashboardBlockCardViewQuery$data;
  variables: CurriculumDashboardBlockCardViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releasedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasCompleted",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocked",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurriculumModule",
  "storageKey": null
},
v14 = [
  (v3/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entity",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creationDatetime",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverVideo",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCoverPlayIcon",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCollectionModule",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v23 = [
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v25 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v22/*: any*/),
  (v24/*: any*/)
],
v26 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v22/*: any*/),
  (v24/*: any*/)
],
v27 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nonNullProductId",
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v22/*: any*/),
        (v24/*: any*/)
      ],
      "type": "Product",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v25/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v26/*: any*/),
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v26/*: any*/),
      "type": "Feed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v26/*: any*/),
      "type": "Post",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nullableProductIdString",
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        },
        (v22/*: any*/),
        (v24/*: any*/)
      ],
      "type": "ContentUsage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v26/*: any*/),
      "type": "ChatChannel",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v26/*: any*/),
      "type": "Dashboard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v25/*: any*/),
      "type": "AssignmentSubmission",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "PathwayGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "BrainSearch",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CurriculumDashboardBlockCardViewQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Curriculum",
                "kind": "LinkedField",
                "name": "curriculum",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": (v4/*: any*/),
                    "kind": "FragmentSpread",
                    "name": "CurriculumDashboardBlockCardViewPaginationFragment"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "usePermissionsFragment"
              }
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CurriculumDashboardBlockCardViewQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Curriculum",
                "kind": "LinkedField",
                "name": "curriculum",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": (v4/*: any*/),
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "modules",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsageNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentUsage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v8/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Content",
                                                "kind": "LinkedField",
                                                "name": "content",
                                                "plural": false,
                                                "selections": [
                                                  (v11/*: any*/),
                                                  (v3/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  {
                                    "alias": "createCurriculumModuleItemContentUsageButtonChildren",
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v13/*: any*/),
                                  {
                                    "alias": "allChildren",
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsageNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentUsage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v14/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Curriculum",
                                "kind": "LinkedField",
                                "name": "curriculum",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "product",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "slug",
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v15/*: any*/),
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "productId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsageNodeConnection",
                                "kind": "LinkedField",
                                "name": "dependents",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsage",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              (v3/*: any*/),
                                              (v11/*: any*/),
                                              (v12/*: any*/),
                                              (v10/*: any*/),
                                              (v17/*: any*/),
                                              (v18/*: any*/),
                                              (v19/*: any*/),
                                              (v20/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "description",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ContentUsageNodeConnection",
                                                "kind": "LinkedField",
                                                "name": "children",
                                                "plural": false,
                                                "selections": [
                                                  (v6/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentUsageNodeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ContentUsage",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v3/*: any*/),
                                                          (v8/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Content",
                                                            "kind": "LinkedField",
                                                            "name": "content",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "contentLabelId",
                                                                "storageKey": null
                                                              },
                                                              (v3/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v7/*: any*/),
                                          (v8/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "dueAt",
                                            "storageKey": null
                                          },
                                          (v15/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "kind": "LinkedField",
                                            "name": "product",
                                            "plural": false,
                                            "selections": [
                                              (v10/*: any*/),
                                              (v3/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "module",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              (v21/*: any*/),
                                              (v10/*: any*/),
                                              (v3/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v9/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "passPercentage",
                                            "storageKey": null
                                          },
                                          (v16/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "module",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsageNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentUsage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Content",
                                                "kind": "LinkedField",
                                                "name": "content",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  (v11/*: any*/),
                                                  (v10/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "systemTaskKind",
                                                    "storageKey": null
                                                  },
                                                  (v12/*: any*/),
                                                  (v17/*: any*/),
                                                  (v18/*: any*/),
                                                  (v19/*: any*/),
                                                  (v20/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v21/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductApp",
                                "kind": "LinkedField",
                                "name": "productApp",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customAppTitle",
                                    "storageKey": null
                                  },
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "kind",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "organizationId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OccurrenceNodeConnection",
                                "kind": "LinkedField",
                                "name": "occurrences",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OccurrenceNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Occurrence",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v14/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              (v27/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfoObjectType",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__id",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v4/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "CurriculumDashboardBlockCardView__modules",
                    "kind": "LinkedHandle",
                    "name": "modules"
                  }
                ],
                "storageKey": null
              },
              (v27/*: any*/)
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c2367036ec3523f896cf638fd94ad85d",
    "id": null,
    "metadata": {},
    "name": "CurriculumDashboardBlockCardViewQuery",
    "operationKind": "query",
    "text": "query CurriculumDashboardBlockCardViewQuery(\n  $id: ID!\n  $first: Int\n) {\n  product: node(id: $id) {\n    __typename\n    ... on Product {\n      curriculum {\n        id\n        ...CurriculumDashboardBlockCardViewPaginationFragment_3ASum4\n      }\n      ...usePermissionsFragment\n    }\n    id\n  }\n}\n\nfragment ContentModuleAdminDropdownFragment on ContentUsage {\n  id\n  entity\n  ...CreateContentModuleItemButtonFragment\n  ...UpdateContentModuleButtonFragment\n  ...DeleteContentUsageButtonFragment\n  ...ContentUsageAssociateEventsButtonFragment\n}\n\nfragment ContentModuleCardFragment on ContentUsage {\n  id\n  releasedAt\n  isLocked\n  content {\n    name\n    id\n    children {\n      edges {\n        node {\n          id\n          viewerHasCompleted\n          content {\n            type\n            id\n          }\n        }\n      }\n    }\n  }\n  curriculum {\n    product {\n      slug\n      id\n    }\n    id\n  }\n  ...ContentUsageLockIconFragment\n  ...ContentModuleAdminDropdownFragment\n  ...usePermissionsFragment\n}\n\nfragment ContentThumbnailWithDetails_ContentFragment on Content {\n  id\n  type\n  label\n  name\n  creationDatetime\n  ...ContentThumbnail_ContentFragment\n}\n\nfragment ContentThumbnailWithDetails_ContentUsageFragment on ContentUsage {\n  id\n  dueAt\n  entity\n  product {\n    name\n    id\n  }\n  module {\n    isCurriculumModule\n    isCollectionModule\n    name\n    id\n  }\n}\n\nfragment ContentThumbnail_ContentFragment on Content {\n  id\n  type\n  coverVideo\n  thumbnailUrl\n  showCoverPlayIcon\n}\n\nfragment ContentUsageAssociateEventsButtonFragment on ContentUsage {\n  id\n  productId\n  organizationId\n  occurrences {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment ContentUsageLockIconFragment on ContentUsage {\n  id\n  entity\n  content {\n    name\n    id\n  }\n  ...UpdateContentModuleButtonFragment\n  ...usePermissionsFragment\n}\n\nfragment ContentUsagePrerequisiteItemFragment on ContentUsage {\n  id\n  releasedAt\n  viewerHasCompleted\n  ...ContentThumbnailWithDetails_ContentUsageFragment\n  isLocked\n  passPercentage\n  content {\n    id\n    isCurriculumModule\n    ...ContentThumbnailWithDetails_ContentFragment\n    name\n    type\n    description\n    children {\n      totalCount\n      edges {\n        node {\n          id\n          viewerHasCompleted\n          content {\n            type\n            contentLabelId\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ContentUsageUtils_UseParentEntityContentUsageFragment on ContentUsage {\n  id\n  entity\n  module {\n    isCurriculumModule\n    isCollectionModule\n    id\n  }\n  productApp {\n    kind\n    id\n  }\n}\n\nfragment ContentUsageUtils_useNavigateToNextContentUsageFragment on ContentUsage {\n  id\n  module {\n    children {\n      edges {\n        node {\n          id\n          content {\n            id\n            type\n            name\n            systemTaskKind\n            ...ContentThumbnailWithDetails_ContentFragment\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment CreateCollectionModuleItemContentUsageButtonFragment on ContentUsage {\n  id\n  content {\n    id\n  }\n  productId\n}\n\nfragment CreateContentModuleItemButtonFragment on ContentUsage {\n  id\n  entity\n  ...CreateCollectionModuleItemContentUsageButtonFragment\n  ...CreateCurriculumModuleItemContentUsageButtonFragment\n}\n\nfragment CreateCurriculumModuleItemContentUsageButtonFragment on ContentUsage {\n  id\n  entity\n  entityId\n  content {\n    id\n    createCurriculumModuleItemContentUsageButtonChildren: children {\n      totalCount\n    }\n  }\n  productId\n}\n\nfragment CurriculumDashboardBlockCardViewPaginationFragment_3ASum4 on Curriculum {\n  modules(first: $first) {\n    totalCount\n    edges {\n      node {\n        id\n        releasedAt\n        viewerHasCompleted\n        ...ContentModuleCardFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment DeleteContentUsageButtonFragment on ContentUsage {\n  id\n  isLocked\n  entity\n  entityId\n  productId\n  dependents {\n    edges {\n      node {\n        id\n        content {\n          isCurriculumModule\n          id\n        }\n        ...ContentUsagePrerequisiteItemFragment\n        ...UpdateContentModuleButtonFragment\n      }\n    }\n  }\n  module {\n    isCurriculumModule\n    id\n  }\n  content {\n    type\n    label\n    isCurriculumModule\n    allChildren: children {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    id\n  }\n  productApp {\n    customAppTitle\n    id\n  }\n  ...ContentUsageUtils_useNavigateToNextContentUsageFragment\n  ...ContentUsageUtils_UseParentEntityContentUsageFragment\n}\n\nfragment UpdateContentModuleButtonFragment on ContentUsage {\n  id\n  entity\n  entityId\n  content {\n    type\n    label\n    id\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "627c87b9be1ed0c715b2ec2b1bf6f617";

export default node;
